export default __webpack_public_path__ + "static/media/13_2.6c036f87.jpg";